/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUser = /* GraphQL */ `
  query GetUser($username: String!) {
    getUser(username: $username) {
      username
      email
      password
      phone
      ssn
      firstName
      lastName
    }
  }
`;
export const getUserInfo = /* GraphQL */ `
  query GetUserInfo($ssn: String!) {
    getUserInfo(ssn: $ssn) {
      ssn
      accNum
      alerus360id
      cif
      dateOfBirth
    }
  }
`;
export const checkEmails = /* GraphQL */ `
  query CheckEmails($email: String!) {
    checkEmails(email: $email)
  }
`;
export const getConfig = /* GraphQL */ `
  query GetConfig {
    getConfig {
      env
      maintenance
      message
    }
  }
`;
export const getDocuments = /* GraphQL */ `
  query GetDocuments($lob: String) {
    getDocuments(lob: $lob) {
      id
      documentId
      name
      filterType
      container
      lob
      order
    }
  }
`;
export const getFailedLogins = /* GraphQL */ `
  query GetFailedLogins($username: String!) {
    getFailedLogins(username: $username)
  }
`;
export const alertFailedSNAttempt = /* GraphQL */ `
  query AlertFailedSNAttempt($email: String!) {
    alertFailedSNAttempt(email: $email)
  }
`;
export const getUserCode = /* GraphQL */ `
  query GetUserCode($username: String!, $code: String!) {
    getUserCode(username: $username, code: $code)
  }
`;
export const getUserDetails = /* GraphQL */ `
  query GetUserDetails($arguments: String, $func: String) {
    getUserDetails(arguments: $arguments, func: $func) {
      a360id
      username
      preferredName
      first
      last
      email
      phones
      address1
      address2
      city
      state
      zip
      primary
      allowText
      cif
      lastReview
      blocked
      defaultMfa
      totpEnabled
      totpDevices
      lastChallenge
      birthdate
      status
      passwordReset
    }
  }
`;
export const getUserByEmail = /* GraphQL */ `
  query GetUserByEmail($arguments: String, $func: String) {
    getUserByEmail(arguments: $arguments, func: $func)
  }
`;
export const getIpAddresses = /* GraphQL */ `
  query GetIpAddresses($func: String) {
    getIpAddresses(func: $func) {
      address
    }
  }
`;
export const getSecrets = /* GraphQL */ `
  query GetSecrets($arguments: String, $func: String) {
    getSecrets(arguments: $arguments, func: $func) {
      id
      a360id
      name
      value
    }
  }
`;
